import { FE_MIGRATE_USER_STORE_250222 } from "@faire/retailer-settings/FE_MIGRATE_USER_STORE_250222";

import { useSetting } from "./__internal__/useSetting";

export const useSettingUserStoreHooksMigration = () => {
  return useSetting(FE_MIGRATE_USER_STORE_250222);
};
